module.exports = __webpack_public_path__ + "static/media/hakkasan.d4b187ea.webp";